import { render, staticRenderFns } from "./lastDeal.vue?vue&type=template&id=2c054796&scoped=true"
import script from "./lastDeal.vue?vue&type=script&lang=js"
export * from "./lastDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c054796",
  null
  
)

export default component.exports